import { ErrorBoundary } from '@rollbar/react';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/app';
import CacheErrorBoundary from '@/components/cache-error-boundary';
import UpdateToaster from '@/components/cache-error-boundary/update-toaster';
import SocketContextProvider from '@/contexts/socket/socket-context-provider';
import ReactQueryProvider from '@/lib/react-query-provider';

import '@/lib/rollbar';
import '@/index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CacheErrorBoundary>
      <ErrorBoundary>
        <ReactQueryProvider>
          <BrowserRouter>
            <SocketContextProvider>
              <App />
              <UpdateToaster />
            </SocketContextProvider>
          </BrowserRouter>
        </ReactQueryProvider>
      </ErrorBoundary>
    </CacheErrorBoundary>
  </StrictMode>
);
